/**
 * @generated SignedSource<<5f4f0d219136b3c5c40cc87375667116>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
export type LockReservationFlow = "GOODS_RECEPTION" | "SWAP" | "%future added value";
export type OrganizationScope = "CLICK_N_COLLECT" | "LOCK_B2B" | "LOCK_B2C" | "MANUAL_ORDER" | "ONEDELIVERY" | "PHARMACY" | "RAFFLE" | "SHOP_N_COLLECT" | "T1" | "T2" | "VENDING" | "WARENANNAHME" | "%future added value";
export type HomePageDataQuery$variables = {
  includeGrants: boolean;
  includeOrganization: boolean;
  organizationId: string;
};
export type HomePageDataQuery$data = {
  readonly hubMetas: {
    readonly nodes: ReadonlyArray<{
      readonly hub: {
        readonly id: string;
        readonly meta: {
          readonly services: ReadonlyArray<HubService>;
        } | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      };
      readonly serviceProviders: ReadonlyArray<{
        readonly id: string;
        readonly logo: {
          readonly id: string;
          readonly variant: string;
        } | null | undefined;
        readonly name: string;
      }>;
    }>;
  };
  readonly myUtilizationGrants?: {
    readonly nodes: ReadonlyArray<{
      readonly deactivatedAt: any | null | undefined;
      readonly reservation: {
        readonly deactivatedAt: any | null | undefined;
        readonly flow: LockReservationFlow;
        readonly subtype: {
          readonly __typename: string;
        };
      };
    }>;
  } | null | undefined;
  readonly onedeliveryAccess?: boolean | null | undefined;
  readonly organization?: {
    readonly id: string;
    readonly scopes: ReadonlyArray<OrganizationScope>;
  } | null | undefined;
};
export type HomePageDataQuery = {
  response: HomePageDataQuery$data;
  variables: HomePageDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeGrants"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOrganization"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onedeliveryAccess",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "input",
      "value": {}
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000
      }
    }
  ],
  "concreteType": "UtilizationGrantPage",
  "kind": "LinkedField",
  "name": "myUtilizationGrants",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UtilizationGrant",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LockReservation",
          "kind": "LinkedField",
          "name": "reservation",
          "plural": false,
          "selections": [
            (v4/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flow",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "subtype",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "organizationId"
    }
  ],
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000000
      }
    }
  ],
  "concreteType": "HubMetaPage",
  "kind": "LinkedField",
  "name": "hubMetas",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HubMeta",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            (v6/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Hub",
          "kind": "LinkedField",
          "name": "hub",
          "plural": false,
          "selections": [
            (v6/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "HubMeta",
              "kind": "LinkedField",
              "name": "meta",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "services",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "serviceProviders",
          "plural": true,
          "selections": [
            (v6/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CloudflareImage",
              "kind": "LinkedField",
              "name": "logo",
              "plural": false,
              "selections": [
                (v6/*:: as any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "variant",
                      "value": "PUBLIC"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "variant",
                  "storageKey": "variant(variant:\"PUBLIC\")"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "hubMetas(pagination:{\"page\":0,\"pageSize\":1000000})"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageDataQuery",
    "selections": [
      {
        "condition": "includeGrants",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "CatchField",
            "field": (v3/*:: as any*/),
            "to": "NULL"
          },
          {
            "kind": "CatchField",
            "field": (v5/*:: as any*/),
            "to": "NULL"
          }
        ]
      },
      {
        "condition": "includeOrganization",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "CatchField",
            "field": (v7/*:: as any*/),
            "to": "NULL"
          }
        ]
      },
      (v8/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "HomePageDataQuery",
    "selections": [
      {
        "condition": "includeGrants",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v3/*:: as any*/),
          (v5/*:: as any*/)
        ]
      },
      {
        "condition": "includeOrganization",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v7/*:: as any*/)
        ]
      },
      (v8/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "2f968d2323fe2375830c9fdb497d9d64",
    "id": null,
    "metadata": {},
    "name": "HomePageDataQuery",
    "operationKind": "query",
    "text": "query HomePageDataQuery(\n  $includeGrants: Boolean!\n  $organizationId: UUID!\n  $includeOrganization: Boolean!\n) {\n  onedeliveryAccess @include(if: $includeGrants)\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) @include(if: $includeGrants) {\n    nodes {\n      deactivatedAt\n      reservation {\n        deactivatedAt\n        flow\n        subtype {\n          __typename\n        }\n      }\n    }\n  }\n  organization(id: $organizationId) @include(if: $includeOrganization) {\n    id\n    scopes\n  }\n  hubMetas(pagination: {page: 0, pageSize: 1000000}) {\n    nodes {\n      id\n      organization {\n        id\n      }\n      hub {\n        id\n        meta {\n          services\n        }\n      }\n      serviceProviders {\n        id\n        name\n        logo {\n          id\n          variant(variant: PUBLIC)\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe17dc0e37b4dcb643d239224dd9d65c";

export default node;
